import { NgModule } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';

import { TiimeButtonModule } from '../button';

@NgModule({
  imports: [MatDialogModule, TiimeButtonModule],
  exports: [MatDialogModule],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        panelClass: 'tiime-dialog-panel',
        backdropClass: 'tiime-backdrop-dialog',
        hasBackdrop: true,
        closeOnNavigation: true,
        enterAnimationDuration: 0
      }
    }
  ],
  declarations: []
})
export class TiimeDialogModule {}
